import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal, SectionHead } from "@/components/Reveal";

const sides = {
  front: {
    src: "/assets/cover-vorderseite.png",
    alt: "Buchcover BlaulichtPraxis – Datenschutz in der Blaulichtfamilie (Vorderseite)",
    label: "Vorderseite",
  },
  back: {
    src: "/assets/cover-rueckseite.png",
    alt: "Buchcover BlaulichtPraxis – Datenschutz in der Blaulichtfamilie (Rückseite)",
    label: "Rückseite",
  },
};

const BookView = () => {
  const [side, setSide] = useState("front");

  return (
    <section
      id="buch"
      data-testid="book-view-section"
      className="py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <SectionHead
            overline="Das Buch"
            title="Ein Blick ins Buch"
            sub="BlaulichtPraxis – Datenschutz in der Blaulichtfamilie. Das Praxishandbuch für Feuerwehr, Rettungsdienst, THW und Hilfsorganisationen – von Jörg Eisbach."
          />
          <Reveal delay={0.15}>
            <div
              className="mt-10 inline-flex rounded-full border border-white/10 bg-navy-800/70 p-1"
              role="group"
              aria-label="Buchansicht wählen"
            >
              {Object.entries(sides).map(([key, s]) => (
                <button
                  key={key}
                  type="button"
                  data-testid={`book-toggle-${key}`}
                  onClick={() => setSide(key)}
                  aria-pressed={side === key}
                  className={`rounded-full px-6 py-2.5 text-sm font-semibold transition-[background-color,color] duration-200 ${
                    side === key
                      ? "bg-blau text-white"
                      : "text-gray-400 hover:text-white"
                  }`}
                >
                  {s.label}
                </button>
              ))}
            </div>
            <p className="mt-8 text-sm text-gray-500 max-w-md leading-relaxed">
              Das Cover greift die Welt der Einsatzorganisationen auf: dunkles
              Navy, Blaulicht-Blau und die klare Sprache der Praxis.
            </p>
          </Reveal>
        </div>

        <Reveal className="flex justify-center">
          <div
            className="relative"
            style={{ perspective: 1400 }}
            data-testid="book-view-stage"
          >
            <div
              aria-hidden="true"
              className="absolute -inset-10 rounded-full bg-[radial-gradient(circle,rgba(0,102,255,0.18)_0%,rgba(10,15,29,0)_70%)]"
            />
            <AnimatePresence mode="wait">
              <motion.img
                key={side}
                src={sides[side].src}
                alt={sides[side].alt}
                data-testid="book-view-image"
                initial={{ rotateY: 70, opacity: 0 }}
                animate={{ rotateY: 0, opacity: 1 }}
                exit={{ rotateY: -70, opacity: 0 }}
                transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                className="book-shadow relative w-full max-w-[340px] sm:max-w-[400px] rounded-md"
                loading="lazy"
              />
            </AnimatePresence>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default BookView;
